import { Tooltip } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { AgentListData } from 'api/agent';
import moment from 'moment';
// import RejectModal from '../components/RejectModal';
// import ViewAuditModal from '../components/ViewAuditModal';
// import * as XLSX from 'xlsx';
// import { saveAs } from 'file-saver';
// import { PaymentListData, getAuditLog } from 'api/dashboard';

function getFullDate(date: string) {
  if (date != null) {
    const dateMoment = moment(new Date(date)).format('DD/MM/YYYY HH:mm:ss');
    return dateMoment;
  }
}

export const FilterColumns: ColumnsType<AgentListData> = [
  {
    key: 'MandateId',
    title: 'Mandate Request ID',
    dataIndex: 'MandateId',
    fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'LANumber',
    title: 'LAN Number',
    dataIndex: 'LANumber',
    fixed: 'left',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'MandateAmount',
    title: 'Mandate Amount',
    dataIndex: 'MandateAmount',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'LoanAmount',
    title: 'Loan Amount',
    dataIndex: 'LoanAmount',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'ShortLink',
    title: 'ShortLink',
    dataIndex: 'ShortLink',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'EmailTo',
    title: 'Email To',
    dataIndex: 'EmailTo',
    ellipsis: true,
    width: 250,
    align: 'center',
  },
  {
    key: 'Email_ApplicantType',
    title: 'EmailApplicantType',
    dataIndex: 'Email_ApplicantType',
    ellipsis: true,
    width: 250,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'EmailSendTo',
    title: 'EmailID',
    dataIndex: 'EmailSendTo',
    ellipsis: true,
    width: 250,
    align: 'center',
  },
  // {
  //   key: 'Email_ApplicantType',
  //   title: 'Applicant Type',
  //   dataIndex: 'Email_ApplicantType',
  //   ellipsis: true,
  //   align: 'center',
  //   render: (record) => (
  //     <Tooltip placement="topLeft" title={record}>
  //       {record}
  //     </Tooltip>
  //   ),
  // },

  {
    key: 'EmailSentDate',
    title: 'Email Sent Date & Time',
    dataIndex: 'EmailSentDate',
    ellipsis: true,
    align: 'center',
    render: (date: string) => getFullDate(date),
    //onFilter: (value: any, record: { PAYMENTPURPOSE: string | any[]; }) => record.PAYMENTPURPOSE.indexOf(value) === 0,
  },
  {
    key: 'EmailStatus',
    title: 'Email Status',
    dataIndex: 'EmailStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'SMSTo',
    title: 'SMS To',
    dataIndex: 'SMSTo',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'SMS_ApplicantType',
    title: 'SMSApplicantType',
    dataIndex: 'SMS_ApplicantType',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },
  {
    key: 'ContactNo',
    title: 'Contact No',
    dataIndex: 'ContactNo',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
    //onFilter: (value: any, record: { NEW_STATUS: string | any[]; }) => record.NEW_STATUS.indexOf(value) === 0,
  },
  {
    key: 'SMSSentDate',
    title: 'SMS Sent Date & Time',
    dataIndex: 'SMSSentDate',
    ellipsis: true,
    align: 'center',
    render: (date: string) => getFullDate(date),
  },
  {
    key: 'SMSStatus',
    title: 'SMS Status',
    dataIndex: 'SMSStatus',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  {
    key: 'CreatedOn',
    title: 'Created Date',
    dataIndex: 'CreatedOn',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {getFullDate(record)}
      </Tooltip>
    ),
  },

  {
    key: 'CreatedBy',
    title: 'Created By',
    dataIndex: 'CreatedBy',
    ellipsis: true,
    align: 'center',
    render: (record) => (
      <Tooltip placement="topLeft" title={record}>
        {record}
      </Tooltip>
    ),
  },

  // {
  //   key: 'Action',
  //   title: 'Action / Status',
  //   dataIndex: 'Action',
  //   ellipsis: true,
  //   // width: 300,
  //   width: 1000,
  //   align: 'center',
  //   render: (record) => (
  //     <span
  //       style={{
  //         display: 'flex',
  //         flexDirection: 'column',
  //         gap: '4px',
  //         // marginRight: '40px',
  //       }}
  //     >
  //       <>
  //         {record?.status !== 'Pending' ? (
  //           <>
  //             <Button type="primary" style={{ flex: '1' }}>
  //               Approve
  //             </Button>
  //             <RejectModal record={record} />
  //           </>
  //         ) : (
  //           <Tooltip placement="topLeft" title={record?.status}>
  //             {record?.status}
  //           </Tooltip>
  //         )}
  //       </>
  //     </span>
  //   ),
  // },
  // {
  //   key: 'View',
  //   title: 'View',
  //   dataIndex: 'View',
  //   ellipsis: true,
  //   // width: 300,
  //   width: 1000,
  //   align: 'center',
  //   render: (_, record) => (
  //     <span
  //       style={{
  //         display: 'flex',
  //         flexDirection: 'column',
  //         gap: '4px',
  //         // marginRight: '40px',
  //       }}
  //     >
  //       <ViewAuditModal record={record} />
  //       <Button onClick={() => DownloadAudit(record)} type="primary" style={{ flex: '1' }}>
  //         Download
  //       </Button>
  //     </span>
  //   ),
  // },
];

// function DownloadAudit(record: AgentListData) {
//   console.log(record);
// getAuditLog(record.PaymentRequestID, false).then((res) => {
//   console.log(res);
//   const { data } = res;
//   const fileName = 'RequestResponse_' + record.PaymentRequestID + '.xlsx';

//   // Convert JSON to worksheet
//   const worksheet = XLSX.utils.json_to_sheet(data);

//   // Create a new workbook and append the worksheet
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

//   // Write workbook to binary array buffer
//   const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });

//   // Convert binary array buffer to Blob for downloading
//   const blob = new Blob([s2ab(wbout)], { type: 'application/octet-stream' });

//   // Save the Blob to file
//   saveAs(blob, fileName);
// });
// }

// Utility function to convert string to ArrayBuffer
// function s2ab(s: any) {
//   const buf = new ArrayBuffer(s.length);
//   const view = new Uint8Array(buf);
//   for (let i = 0; i < s.length; i++) {
//     view[i] = s.charCodeAt(i) & 0xff;
//   }
//   return buf;
// }

export default FilterColumns;
